import http from '../jslibs/axios/http';

//充值管理 充值档次列表
export const rechargeList = () => (http.get('/v1/cms/Recharge'));

//充值管理 新增充值档次
export const addRecharge = data => (http.post('/v1/cms/Recharge', data));

//充值管理 编辑充值档次
export const editRecharge = data => (http.put(`/v1/cms/Recharge/${data.uuid}`, data));

//充值管理 删除充值档次
export const deleteRecharge = uuid => (http.delete(`/v1/cms/Recharge/${uuid}`));

//充值管理 充值记录列表
export const rechargeRecordsList = data => (http.get('/v1/cms/UserRechargeRecord', data));